import { polygonsIntersect, signedDistanceToPolygon } from "@energyos/geometry-core";
const EPS = 1e-6;
/**
 * Liegt das Modul-Rechteck mit Randabstand vollständig im Dach?
 * Prüft die vorzeichenbehaftete Randdistanz jeder Ecke (innen +, außen −):
 * alle Ecken müssen ≥ setbackM vom Dachrand entfernt sein.
 */
export function moduleInsideRoof(moduleCorners, roof2d, setbackM) {
    for (const c of moduleCorners) {
        if (signedDistanceToPolygon(c, roof2d) < setbackM - EPS)
            return false;
    }
    return true;
}
/** Berührt/überlappt das Modul eine Keepout-Zone (inkl. Clearance)? */
export function moduleHitsKeepout(moduleCorners, keepout) {
    if (polygonsIntersect(moduleCorners, keepout.poly))
        return true;
    if (keepout.clearanceM > 0) {
        for (const c of moduleCorners) {
            // signed > -clearance  ⇔  Ecke innen ODER näher als clearance am Rand
            if (signedDistanceToPolygon(c, keepout.poly) > -keepout.clearanceM + EPS)
                return true;
        }
    }
    return false;
}
/** Modul gültig: im Dach (mit Randabstand) UND keine Keepout-Kollision. */
export function moduleIsPlaceable(moduleCorners, roof2d, keepouts, setbackM) {
    if (!moduleInsideRoof(moduleCorners, roof2d, setbackM))
        return false;
    for (const k of keepouts) {
        if (moduleHitsKeepout(moduleCorners, k))
            return false;
    }
    return true;
}
//# sourceMappingURL=clip.js.map